import * as React from 'react';
import { Provider } from 'react-redux';
import store from './store';

export const StoreProvider = ({children}): React.ReactElement => {
    return <Provider store={store}>{children}</Provider>;
};